import SteveAndKateHeader from '@/images/bh-benefits/steve_and_kates_header.webp';
import GTMHeader from '@/images/bh-benefits/gtm_payroll_header.jpg';
import ProTrainingsHeader from '@/images/bh-benefits/pro_trainings_header.jpg';
import BrightHorizonsHeader from '@/images/bh-benefits/bh_centers_header.jpg';
import ProTrainingsLogo from '@/images/bh-benefits/pro-trainings-logo.svg';
import LittleSpoonHeader from '@/images/bh-benefits/little_spoon_header.jpg';
import NapsHeader from '@/images/bh-benefits/naps_header.jpg';

import steveAndKatesCampsZipCodes from './constants/steve_and_kates_camps_zip_codes';

export enum PartnerCategory {
  daycare = 'Daycare',
  familyResources = 'Family Resources',
  camps = 'Camps',
  education = 'Education',
}

enum PartnerGroups {
  CAMPS_AND_EDUCATION = 'CAMPS_AND_EDUCATION',
  FAMILY_RESOURCES = 'FAMILY_RESOURCES',
}
export interface PartnerCard {
  headerImage: string;
  companyName: string;
  title: string;
  detailsUrl: string;
  category: PartnerCategory;
  ages?: string;
  displayZipCodes?: Array<string>;
}

const GTM_PARTNER_KEY = 'GTM_Payroll_Care_Support';
const GTM_PARTNER_CARD_DATA: PartnerCard = {
  headerImage: GTMHeader,
  companyName: 'GTM Payroll',
  title: 'Nanny tax & payroll support',
  detailsUrl: 'https://gtm.com/household/sittercity/',
  category: PartnerCategory.familyResources,
};

const STEVE_AND_KATES_CAMPS_KEY = 'SteveandKates_Camps';
const STEVE_AND_KATES_CAMPS_CARD_DATA: PartnerCard = {
  headerImage: SteveAndKateHeader,
  companyName: `Steve & Kate's Camp`,
  category: PartnerCategory.camps,
  title: 'Flexible camps for school breaks',
  detailsUrl:
    'https://steveandkatescamp.com/bh-family-benefits/?utm_source=sittercity&utm_medium=campTile&utm_campaign=sittercity_tile',
  ages: '4-12',
  displayZipCodes: steveAndKatesCampsZipCodes,
};

const PRO_TRAININGS_CPR_FAMILY_KEY = 'ProTrainings_CPR_Family';
const PRO_TRAININGS_CPR_FAMILY_CARD_DATA: PartnerCard = {
  headerImage: ProTrainingsHeader,
  companyName: 'ProTrainings',
  category: PartnerCategory.familyResources,
  title: 'CPR & first aid trainings',
  detailsUrl: 'https://www.protrainings.com/sittercity-families',
};

const BRIGHT_HORIZONS_CENTERS_KEY = 'BrightHorizons_Centers';
const BRIGHT_HORIZONS_CENTERS_CARD_DATA: PartnerCard = {
  headerImage: BrightHorizonsHeader,
  companyName: 'Bright Horizons',
  category: PartnerCategory.daycare,
  title: 'Educational child care centers',
  ages: '0-5',
  detailsUrl:
    'https://www.brighthorizons.com/child-care-locator?utm_source=sittercity&utm_medium=org-digitalad&utm_campaign=leadmarketing&utm_term=sittercitydashboard&utm_content=centerlocator&IMS_SOURCE_SPECIFY=sittercity|org-digitalad|leadmarketing|sittercitydashboard|centerlocator',
};

const LITTLE_SPOON_CARE_KEY = 'LittleSpoon_Care_Support';
const LITTLE_SPOON_CARE_DATA: PartnerCard = {
  headerImage: LittleSpoonHeader,
  companyName: 'Little Spoon',
  category: PartnerCategory.familyResources,
  title: 'Prepared, nutritious meals & snacks',
  detailsUrl: 'https://www.littlespoon.com/?utm_medium=website&utm_source=partnership&utm_campaign=sittercity',
};

const NAPS_KEY = 'NAPS_Care_Support';
const NAPS_DATA: PartnerCard = {
  headerImage: NapsHeader,
  companyName: 'NAPS Registered Nurses',
  category: PartnerCategory.familyResources,
  title: 'Prenatal and parenting classes',
  ages: '0-3',
  detailsUrl: 'https://www.nurturebynaps.com/sittercity',
};

export const PROTRAININGS_CPR_SITTER_KEY = 'ProTrainings_CPR_Sitter';
export const PROTRAININGS_CPR_SITTER_DATA: object = {
  logoImage: ProTrainingsLogo,
  headerText: 'Get 25% off CPR certification',
  bodyText: 'Learn how to handle over 50 different first aid scenarios from seasoned paramedics—all through a virtual experience',
  ctaText: 'View Training',
  ctaLink: 'https://www.protrainings.com/sittercity-caregivers',
  category: PartnerCategory.familyResources,
};

const ALL_PARENT_PARTNER_CARDS: any = () => ({
  [STEVE_AND_KATES_CAMPS_KEY]: STEVE_AND_KATES_CAMPS_CARD_DATA,
  [GTM_PARTNER_KEY]: GTM_PARTNER_CARD_DATA,
  [PRO_TRAININGS_CPR_FAMILY_KEY]: PRO_TRAININGS_CPR_FAMILY_CARD_DATA,
  [BRIGHT_HORIZONS_CENTERS_KEY]: BRIGHT_HORIZONS_CENTERS_CARD_DATA,
  [LITTLE_SPOON_CARE_KEY]: LITTLE_SPOON_CARE_DATA,
  [NAPS_KEY]: NAPS_DATA,
});

const ALL_PARENT_PARTNER_KEYS = Object.keys(ALL_PARENT_PARTNER_CARDS());

const ALL_CARDS = () => ({
  ...ALL_PARENT_PARTNER_CARDS(),
  ProTrainings_CPR_Sitter: PROTRAININGS_CPR_SITTER_DATA,
});

const CATEGORY_NAMES = () => ({
  [PartnerGroups.CAMPS_AND_EDUCATION]: 'Daycares, camps, and education',
  [PartnerGroups.FAMILY_RESOURCES]: 'Family resources',
});

const partnerCategoryGroup = {
  [PartnerCategory.daycare]: PartnerGroups.CAMPS_AND_EDUCATION,
  [PartnerCategory.familyResources]: PartnerGroups.FAMILY_RESOURCES,
  [PartnerCategory.camps]: PartnerGroups.CAMPS_AND_EDUCATION,
  [PartnerCategory.education]: PartnerGroups.CAMPS_AND_EDUCATION,
};

export default {
  ALL_PARENT_PARTNER_CARDS,
  ALL_PARENT_PARTNER_KEYS,
  ALL_CARDS,
  CATEGORY_NAMES,
  partnerCategoryGroup,
  PartnerGroups,
};
